import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=1055eb44&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1055eb44')) {
      api.createRecord('1055eb44', component.options)
    } else {
      api.reload('1055eb44', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=1055eb44&", function () {
      api.rerender('1055eb44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4seL8oHqL3Odi/JS/priceformat.vue"
export default component.exports